// reducers/hotel.reducer.js
const INITIAL_STATE = {
  hotelId: localStorage.getItem("hotelId"),
  hotelListRefreshKey: 0,
};

const hotelReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_HOTEL_ID":
      return { ...state, hotelId: action.payload };

    case "CLEAR_HOTEL_ID":
      localStorage.removeItem("hotelId");
      return { ...state, hotelId: null };

    case "REFRESH_HOTELS_LIST":
      return { ...state, hotelListRefreshKey: state.hotelListRefreshKey + 1 };

    default:
      return state;
  }
};

export default hotelReducer;
